import { GetAdminVideoHostingQueryOutputProvider } from 'common/api/video-api-schema'
import { Video, VideoHosting } from 'features/videos/service'
import { generateVideoUrlFromId } from 'utils/parseVideoUrl'

import {
  DEFAULT_LOCALE,
  mapLegacyHostingToProvider,
  mapProviderToLegacyHosting,
} from './videoMainForm.shared'
import { VideoHostingForm, VideoLocaleForm, VideoMainFormValues } from './videoMainForm.types'

const buildSourceUrl = (hosting: VideoHosting) =>
  generateVideoUrlFromId(
    mapProviderToLegacyHosting(hosting.provider),
    hosting.hostingId ?? '',
    hosting.hostingHash ?? undefined,
    hosting.url ?? undefined
  )

export const createEmptyLocaleForm = (locale = DEFAULT_LOCALE): VideoLocaleForm => ({
  description: '',
  locale,
  name: '',
  seoDescription: '',
})

export const createEmptyHostingForm = (locale = DEFAULT_LOCALE): VideoHostingForm => ({
  hostingHash: '',
  hostingId: '',
  isPrimary: true,
  locale,
  metadata: '',
  provider: GetAdminVideoHostingQueryOutputProvider.YOUTUBE,
  sourceUrl: '',
  url: '',
})

export const getInitialFormValues = (defaultValues?: Video): VideoMainFormValues => {
  const locales =
    defaultValues?.locales && defaultValues.locales.length > 0
      ? defaultValues.locales.map(locale => ({
          description: locale.description ?? '',
          id: locale.id,
          locale: locale.locale,
          name: locale.name,
          seoDescription: locale.seoDescription ?? '',
        }))
      : [
          {
            ...createEmptyLocaleForm(DEFAULT_LOCALE),
            description: defaultValues?.description ?? '',
            name: defaultValues?.name ?? '',
            seoDescription: defaultValues?.seoDescription ?? '',
          },
        ]

  const hostings =
    defaultValues?.hostings && defaultValues.hostings.length > 0
      ? defaultValues.hostings.map(hosting => ({
          hostingHash: hosting.hostingHash ?? '',
          hostingId: hosting.hostingId ?? '',
          id: hosting.id,
          isPrimary: hosting.isPrimary,
          locale: hosting.locale,
          metadata:
            hosting.metadata && Object.keys(hosting.metadata).length > 0
              ? JSON.stringify(hosting.metadata, null, 2)
              : '',
          provider: hosting.provider,
          sourceUrl: buildSourceUrl(hosting),
          url: hosting.url ?? '',
        }))
      : [
          {
            ...createEmptyHostingForm(DEFAULT_LOCALE),
            hostingHash: defaultValues?.hostingHash ?? '',
            hostingId: defaultValues?.hostingId ?? '',
            provider: mapLegacyHostingToProvider(defaultValues?.hosting),
            sourceUrl: generateVideoUrlFromId(
              defaultValues?.hosting ?? 'youtube',
              defaultValues?.hostingId ?? '',
              defaultValues?.hostingHash ?? undefined,
              defaultValues?.url ?? undefined
            ),
            url: defaultValues?.url ?? '',
          },
        ]

  return {
    code: defaultValues?.code ?? '',
    durationInSeconds: defaultValues?.durationInSeconds ?? null,
    hostings,
    locales,
    mentor: defaultValues?.mentor ?? '',
    mentorId: defaultValues?.mentorId ?? 0,
    publicVisibility: defaultValues?.publicVisibility,
    slug: defaultValues?.slug ?? '',
    startDate: defaultValues?.startDate ?? '',
  }
}
